export default function convertSpecialCharsInList(strings: string[]): string[] {
    return strings.map((text) => {
        const textarea = document.createElement('textarea');
        textarea.innerHTML = text;
        return textarea.value;
    });
}